const Pagination = (props) => {
  const { total, current, setCurrent } = props;
  const getPages = () => {
    var pages = [];
    for (let i = 1; i <= total; i++) {
      pages.push(
        <p
          key={"Page" + i}
          onClick={() => {
            setCurrent(i);
          }}
          className={
            current !== i
              ? "border-transparent mr-4 cursor-pointer border-t px-2 pt-3 text-sm font-medium leading-none text-gray-600 hover:border-indigo-400 hover:text-indigo-700"
              : "mr-4 cursor-pointer border-t border-indigo-400 px-2 pt-3 text-sm font-medium leading-none text-indigo-700"
          }
        >
          {i}
        </p>
      );
    }

    return pages;
  };
  return (
    <div className="flex items-center justify-center py-10 px-4 sm:px-6 lg:px-0">
      <div className="flex  w-full items-center justify-between border-t border-gray-200">
        <div
          onClick={() => {
            if (current > 1) {
              setCurrent(current - 1);
            }
          }}
          className="flex cursor-pointer items-center pt-3 text-gray-600 hover:text-indigo-700"
        >
          <svg
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.1665 4H12.8332"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.1665 4L4.49984 7.33333"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.1665 4.00002L4.49984 0.666687"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p className="ml-3 text-sm font-medium leading-none ">Өмнөх</p>
        </div>
        <div className="hidden sm:flex">{getPages()}</div>
        <div
          onClick={() => {
            if (current < total) {
              setCurrent(current + 1);
            }
          }}
          className="flex cursor-pointer items-center pt-3 text-gray-600 hover:text-indigo-700"
        >
          <p className="mr-3 text-sm font-medium leading-none">Дараах</p>
          <svg
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.1665 4H12.8332"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.5 7.33333L12.8333 4"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.5 0.666687L12.8333 4.00002"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
